import Vue from "vue";
import { EXTERNAL_CHANGES_STATUS } from "@/enums/external-changes";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";
import { UTM_SOURCE, UTM_MEDIUM, UTM_CAMPAIGN } from "@/enums/utm-tags";
import { dev__warnNotify } from "./helpers";

export const gtmEvent__removeUserData = () => {
  Vue.gtm.trackCustomEvent({
    event: GTM_EVENT_NAME.SET_USER_DATA,
    company_id: null,
    user_id: null,
    user_email: null,
    company_is_paying: null,
    company_is_testing: null
  });
};

export const gtmEvent__listSearch = ({ query, resultsNum, component }) => {
  const eventParams = {
    event: GTM_EVENT_NAME.LIST_SEARCH,
    query,
    num_results: resultsNum
  };

  if (component) {
    eventParams.component = component || null;
  }

  Vue.gtm.trackCustomEvent(eventParams);
};

export const gtmEvent__listSelect = ({
  numSelected,
  component,
  action,
  type
}) => {
  Vue.gtm.trackCustomEvent({
    event: GTM_EVENT_NAME.LIST_SELECT,
    num_selected: numSelected,
    component: component || null,
    action: action || null,
    type: type || null
  });
};

export const gtmEvent__filterDatePeriod = ({
  dateFrom,
  dateTo,
  dateInputType,
  compareWith
}) => {
  const eventParams = {
    event: GTM_EVENT_NAME.FILTER_DATE_PERIOD,
    date_from: dateFrom,
    date_to: dateTo,
    date_input_type: dateInputType
  };

  if (compareWith) {
    eventParams.compare_with = compareWith || null;
  }

  Vue.gtm.trackCustomEvent(eventParams);
};

export const gtmEvent__buttonClick = ({ label }) => {
  Vue.gtm.trackCustomEvent({
    event: GTM_EVENT_NAME.BUTTON_CLICK,
    button_title: label
  });
};

export const gtmEvent__locationCreate = ({ locationNum = 1, action }) => {
  Vue.gtm.trackCustomEvent({
    event: GTM_EVENT_NAME.LOCATION_CREATE,
    location_num: locationNum,
    action
  });
};

export const gtmEvent__singleLocationEditSummary = ({ locationId, fields }) => {
  Vue.gtm.trackCustomEvent({
    event: GTM_EVENT_NAME.SINGLE_LOCATION_EDIT_SUMMARY,
    location_id: locationId,
    fields: Array.isArray(fields) ? fields.join(", ") : fields
  });
};

export const gtmEvent__singleExternalChangeAction = ({
  locationId,
  status,
  field,
  origin
}) => {
  Vue.gtm.trackCustomEvent({
    event: GTM_EVENT_NAME.SINGLE_EXTERNAL_CHANGE_ACTION,
    location_id: locationId || null,
    action:
      status === EXTERNAL_CHANGES_STATUS.ACCEPTED
        ? "accept"
        : status === EXTERNAL_CHANGES_STATUS.REJECTED
        ? "reject"
        : null,
    field: field || null,
    origin: origin || null
  });
};

export const gtmEvent__reviewTemplateManageAction = ({ action }) => {
  Vue.gtm.trackCustomEvent({
    event: GTM_EVENT_NAME.REVIEW_TEMPLATE_MANAGE_ACTION,
    action
  });
};

export const gtmEvent__engagedByTime = ({ path, pageName, time }) => {
  Vue.gtm.trackCustomEvent({
    event: GTM_EVENT_NAME.ENGAGED_PAGE_VIEW,
    page_url: path,
    page_name: pageName,
    engagement_time_elapsed: time
  });
};

export const gtmEvent__utmEmailNotification = query => {
  const {
    utm_source: utmSource,
    utm_medium: utmMedium,
    utm_campaign: utmCampaign,
    utm_content: utmContent
  } = query;
  if (utmSource === UTM_SOURCE.NOTIFICATION && utmMedium === UTM_MEDIUM.EMAIL) {
    switch (utmCampaign) {
      case UTM_CAMPAIGN.NOTIFICATION_REVIEWS:
        _trackNotificationEvent({
          event: GTM_EVENT_NAME.NOTIFICATION_REVIEWS,
          origin: utmMedium,
          field: utmContent
        });
        break;
      case UTM_CAMPAIGN.NOTIFICATION_EXTERNAL_CHANGES:
        _trackNotificationEvent({
          event: GTM_EVENT_NAME.NOTIFICATION_EXTERNAL_CHANGES,
          origin: utmMedium,
          field: utmContent
        });
        break;
      default:
        dev__warnNotify("Utm campaign tag not supported.");
    }
  } else {
    dev__warnNotify("Utm source or medium not supported.");
  }
};

const _trackNotificationEvent = ({ event, origin, field }) => {
  Vue.gtm.trackCustomEvent({
    event,
    origin,
    action: "link_clicked",
    field
  });
};
